import Config from 'APP/Config'
import Button from 'APP/Converse/Button'
import { createContext, useCallback, useContext, useEffect, useState } from 'react'
import styled from 'styled-components/native'
import { isIOS } from 'APP/Helpers/checkPlatform'

const DevToolsContext = createContext({
  setToolFunction: (_func: Function | null) => {},
  setToolName: (_toolName: string | null) => {},
  /* istanbul ignore next */
  setHasHelpButton: (_has: boolean) => {},
  clearTools: () => {},
})

const StyledDebugToolsWrapper = styled.View<{ hasHelpButton: boolean }>`
  position: absolute;
  top: ${({ theme }) =>
    theme.metrics.statusBarHeight + theme.metrics.baseMargin * (isIOS() ? 4 : 2)}px;
  right: ${({ theme, hasHelpButton }) =>
    hasHelpButton ? theme.metrics.baseMargin * 4 : theme.metrics.baseMargin / 2}px;
  z-index: 999;
`
const DevToolsProvider = ({ children }: { children: React.ReactNode }) => {
  const [toolFunction, setToolFunction] = useState<Function | null>()
  const [toolName, setToolName] = useState<string | null>()
  const [disabled, setDisabled] = useState<boolean>(false)
  const [hasHelpButton, setHasHelpButton] = useState(false)

  const clearTools = useCallback(() => {
    setToolFunction(null)
    setToolName(null)
  }, [])

  const handleOnPress = () => {
    if (Config.PROD === true || !toolFunction) {
      return
    }
    setDisabled(true)
    toolFunction()
  }

  useEffect(() => {
    setDisabled(false)
  }, [toolFunction])

  return (
    <DevToolsContext.Provider
      value={{ setToolFunction, setToolName, setHasHelpButton, clearTools }}
    >
      {children}
      {Config.PROD === false && toolName && toolFunction && (
        <StyledDebugToolsWrapper hasHelpButton={hasHelpButton}>
          <Button
            disabled={disabled}
            icon="bug"
            iconVariant="material"
            title={toolName}
            widthVariant="content"
            onPress={handleOnPress}
            testID="devtools-button"
          />
        </StyledDebugToolsWrapper>
      )}
    </DevToolsContext.Provider>
  )
}

export default DevToolsProvider

export const useDevTools = () => useContext(DevToolsContext)
